<template>
  <div class="mainContent helpContent">
    <pageHead device="desktop" page="rule" :title="$t('store.dialogRule_title')"/>
    <div class="rule container">
      <h1 class="title lkrule"><span>{{ $t("store.dialogRule_title") }}</span></h1>
      <section class="rule-cont" v-for="item in $t('store.dialogRule_list')">
        <h1 class="title">{{ item.title }}</h1>
        <p>{{ item.cont1 }}</p>
        <p>{{ item.cont2 }}</p>
        <p>{{ item.cont3 }}</p>
        <p>{{ item.cont4 }}</p>
        <p>{{ item.cont5 }}</p>
        <p>{{ item.cont6 }}</p>
        <p>{{ item.cont7 }}</p>
      </section>
    </div>
  </div>
</template>
<script>
  import pageHead from "~/components/common/pageHead.vue";
  export default {
    components: { pageHead }
  };
</script>
